import * as Sentry from '@sentry/vue'
import type { App } from 'vue'

const integrations = [Sentry.browserTracingIntegration(), Sentry.replayIntegration()]

export default function sentryPlugin(app: App): void {
  // @TODO(damon): will recheck root cause for above if condition
  if (import.meta.env.VITE_API_BASE_URL?.includes('lyka.com.au')) {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations,
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['*.lyka.com.au'],
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
  } else {
    console.log(`Sentry is not enabled at ${import.meta.env.PROD ? 'PROD' : 'DEV'} environment.`)
  }
}
